import dayjs from "dayjs";

export const getAssistantsString = (pax) => {
    return pax
        .filter(passenger => passenger.value > 0) // Ignorar si el value es 0
        .map(passenger => `${passenger.value} ${passenger.title}${passenger.value > 1 ? 's' : ''}`) // Formatear texto
        .join(', '); // Unir con comas
}

export const getTotalAssistants = (pax) => {
    return pax.reduce((accumulator, currentValue) => accumulator + currentValue.total, 0);
}



export const prePrareTourBookingData = (tour, date, items, extras) => {
    const getCoverOrDefault = (array, condition) => {
        return array?.find(condition) || array[0] || null;
    };
    const condition = image => image.isCover;
    let cover = getCoverOrDefault(tour.images, condition);

    console.log('cover', items);

    const totalPrice = items.reduce((total, item) => {
        // Suma el precio de cada item
        let itemTotal = item.price * item.value;

        // Suma el precio de extras.activities solo si item.title está en item.pax de extras.activities
        if (extras?.activities) {
            extras.activities.forEach(activity => {
                activity?.rates?.forEach(rate => {
                    if (rate.pax && rate.pax.includes(item.title)) {
                        itemTotal += rate.price * item.value;
                    }
                });
            });
        }

        return total + itemTotal;
    }, 0);

    const tourtoBook = {
        name: tour.name,
        slug: tour.slug,
        city: tour.city.slug,
        country: tour.country.slug,
        cover: cover.imagen,
        booking: items,
        total: totalPrice,
        iva: tour.iva,
        extras: {
            activities: extras?.activities,
            extras: extras?.activities,
        },
        // extras: extras,
        date: dayjs(date).format('YYYY-MM-DD')
    }

    return tourtoBook

}